<template>
  <Anicss
    :enter-active-class="['animated', 'bounceInUp']"
    appear
  >
    <div :class="$style.row">
      <slot name="override">
        <div :class="$style.label">
          <div :class="$style.labelFill"></div>
          <div :class="$style.labelContent">
            <slot name="label"></slot>
          </div>
        </div>
        <div :class="$style.value">
          <slot></slot>
        </div>
      </slot>
    </div>
  </Anicss>
</template>

<script>
import Anicss from '@/components/Anicss'

export default {
  components: {
    Anicss,
  },
}
</script>

<style lang="scss" module>
$width: 200px;
$fontSize: 3rem;

.row {
  @apply flex;
  @apply items-center;
  @apply mb-6;
}

.label {
  width: $width;
  @apply flex;
  @apply mr-8;
}

.labelFill {
  @apply flex-grow;
}

.labelContent {
  font-size: $fontSize;
}

.value {
  width: $width;
  font-size: $fontSize;
  @apply leading-none;
}
</style>
